import React from 'react';
import { useSelector } from 'react-redux';
import * as actionCreator from '../../../../action/index.js';

const Deposit = () => {

  const state = useSelector(state => ({
    ...state.reducer,
    ...state.orderExtrasReducer,
    ...state.priceUpdateReducer
  }));

  const { const_var } = state;
  const buildingPriceArrar = const_var?.BuildingPriceArrar || {};

  const newDownPaymentTotal = buildingPriceArrar.new_down_payment_total ?? 0;
  const grvyValue = buildingPriceArrar.grvy_value ?? 0;
  const customDownPaymentTotal = buildingPriceArrar.custom_down_payment_total ?? 0;
  const downPaymentDiscountTotal = buildingPriceArrar.down_payment_discount_total ?? 0;
  const downPaymentTotal = buildingPriceArrar.down_payment_total ?? 0;

  const depositAmount =
    downPaymentDiscountTotal !== 0
      ? (downPaymentTotal + customDownPaymentTotal).toFixed(2)
      : (newDownPaymentTotal + customDownPaymentTotal + grvyValue).toFixed(2);

  return <span>${depositAmount}</span>;
};

export default Deposit;